// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';


import { gsap } from "gsap";


jQuery(document).ready(function ($) {
    // Esperar a que carguen imagenes y videos
    window.onload = function() {
        // Solo se actualiza el tema del header si estamos en top
        if (!masthead.classList.contains('scrolled-top')) return;
        updateHeaderThemeFromVisual();
    }

    let lastScrollTop = 0;

    const $masthead = $('#masthead');
    // unused: const body = document.querySelector("body");
    const masthead = document.querySelector("#masthead");
    //unused: const logo = document.querySelector(".custom-logo-link");
    const navbar_left = document.querySelector("#site-navigation-left");
    const navbar_right = document.querySelector("#site-navigation-right");
    
    // First page load
    if ($(window).scrollTop() == 0) {
        $masthead.addClass('scrolled-top');
    }

    const px_threshold = 56;
    // const px_threshold = 0;
    let scroll_threshold = 0;

    $(window).on('scroll', function() {
        
        const currentScroll = $(window).scrollTop();

        // Update scroll_threshold to be relative to lastScrollTop
        scroll_threshold = lastScrollTop + px_threshold;


        // Scrolled top - 2px de margen para no hacerlo tan sensible
        if (currentScroll <= 2) {

            $masthead.addClass('scrolled-top show-logo-glasses');
            // $masthead.removeClass('duration-300');
            updateHeaderThemeFromVisual();
            lastScrollTop = currentScroll;

        // Scroll down
        } else if (currentScroll > lastScrollTop ) {

            // setTimeout(() => {
            //     $masthead.removeClass('scrolled-top');
            // }, 300);

            
            
            if (currentScroll > scroll_threshold) { 
            
                $masthead.removeClass('scrolled-top');
                setTimeout(() => {
                    resetHeaderTheme();
                }, 300);

                $masthead.removeClass('header-visible');
                
                // Cuando se baja desde arriba de todo, esperamos el tiempo que tarda
                // el header en esconderse para ocultar el logo de las gafas y los estilos de border-bottom y background
                if (lastScrollTop <= px_threshold) {

                    setTimeout(function() {
                        $masthead.removeClass('show-logo-glasses');
                    }, 300);
                }
                lastScrollTop = currentScroll;
                // $masthead.addClass('duration-300');
            } 
        // Scroll up
        } else if (currentScroll < lastScrollTop) {

            $masthead.addClass('header-visible');
            lastScrollTop = currentScroll;
        }
        
    });

    $("#sidebar-category").on('sidebar_opened', function() {
        // When category sidebar is opened, apply transparent (white) background to the header
        $masthead.addClass('scrolled-top');
    })

    $('input[name="user_type"]').on('change', function () {
        if ($(this).val() === 'professional') {
            $('#extra-fields').slideDown();
        } else {
            $('#extra-fields').slideUp();
        }
    });

    let categorias_parent_id = [];
    $(".menu-parent-items").each(function(){
        categorias_parent_id.push($(this).data("id"));
    });

    $(".menu-parent-items").on("click", function (e) {
        e.preventDefault();

        const parentId = $(this).data("id");
        $(".menu-parent-items").removeClass("active");
        $(".menu-parent-items span").removeClass("w-full opacity-100");
        $(this).addClass("active");
        $(this).find("span").addClass("w-full opacity-100");
        $(".subcategory-group").addClass("hidden");
        $('.subcategory-group[data-parent-id="' + parentId + '"]').removeClass("hidden");

        const $group = $('.subcategory-group[data-parent-id="' + parentId + '"]').removeClass("hidden");

        // Buscar el primer acordeón visible (sin .hidden)
        const $accordion = $group.find('[data-accordion]:not(.hidden)').first();

        // Si existe, disparar su toggle (lo abre o lo mantiene coherente con tu script)
        if ($accordion.length && !$accordion.hasClass('open')) {
            $accordion.find('[data-toggle-accordion]').trigger('click');
        }
        

        let slug_category = $(this).data('category').toLowerCase();
        if(slug_category === 'lighting' || slug_category === 'furniture' || slug_category === 'iluminación' || slug_category === 'mobiliario'){
            $('.open-sidebar-fullindex').removeClass('hidden');
            $('.product-index').text($(this).data('category'));
            $('.product-index').attr('data-category', slug_category);
        }else{
            $('.open-sidebar-fullindex').addClass('hidden');
        }
        $('.close-the-product-index').text($(this).data('category'));

        const $sidebar = $(".sidebar-subcategory");
        if (!$sidebar.hasClass("open")) {
            $sidebar.removeClass("-translate-x-full").addClass("open translate-x-[100%]");
        }

        updateBodyOverflow();
    });

    $(".menu-parent-items.active span").addClass("w-full opacity-100");
    let slug_category = $('.menu-parent-items.active').data('category').toLowerCase();
    if(slug_category === 'lighting' || slug_category=== 'furniture' || slug_category === 'iluminación' || slug_category=== 'mobiliario'){
        $('.open-sidebar-fullindex').removeClass('hidden');
        $('.product-index').text($('.menu-parent-items.active').data('category'))
        $('.product-index').attr('data-category', slug_category);
    }else{
        $('.open-sidebar-fullindex').addClass('hidden');
    }
    $('.close-the-product-index').text($('.menu-parent-items.active').data('category'));

    function updateSidebarPosition() {
        let $header = $("#masthead");
        let $sidebar = $(".fullmenu-content");

        if ($header.length && $sidebar.length) {
            let headerHeight = $header.outerHeight();
            $sidebar.css({
                "marginTop": `${headerHeight}px`,
            });
        }
    }

    $(window).on("load resize", updateSidebarPosition);

    // Controlar overflow-y del body
    function updateBodyOverflow() {
        if ($('.sc-sidebar.open').length > 0) {
            $('body').addClass('overflow-hidden');
        } else {
            $('body').removeClass('overflow-hidden');
        }
    }

    // Escuchar cuando se cierra un sidebar
    $(document).on('click', '.close-sidebar, .body-overlay', function () {
        setTimeout(updateBodyOverflow, 100); // retraso para permitir el cierre del sidebar
    });

    // También si se cierra con ESC
    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            setTimeout(updateBodyOverflow, 100);
        }
    });

    //////////////////////////

    function load_product_index_carousel(category_id) {

        const $carousel_container = $(`.products-category-container[data-id=${category_id}] [data-pill-content=product-index-carousel]`);

        // Exit if already loaded the content
        if ($carousel_container.hasClass('loaded')) {
            return;
        }

        $.ajax({
            url: window.translations.ajax_url,
            method: 'POST',
            data: {
                action: 'get_product_index_carousel_html',
                parent_cat: category_id,
                nonce: window.translations.sidebar_products_nonce
            },
            success: function(data) {
                if (data) {
                    $carousel_container.html(data);
                    $carousel_container.addClass('loaded');

                    // Init every subcategory carousel
                    $carousel_container.find('.sc-swiper').each(function() {
                        new Swiper(this, {
                            'slidesPerView': 3.2,
                            'spaceBetween': 6,
                            'freeMode': true
                        });
                    })
                    
                } else {
                    $carousel_container.html('<p class="text-red-500 p-2">Error loading content</p>');
                }
            },
            error: function() {
                $carousel_container.html('<p class="text-red-500 p-2">Server error</p>');
            }
        });
    }

    $('.open-sidebar-fullindex').on('click', function () {
        const category_id = $('.menu-parent-items.product.active').data('id');
        load_product_index_carousel(category_id);
    });

    // Toggles the visibility of the selected category product full-index
    $("#sidebar-fullindex").on('sidebar_opened', function() {

        const category_id = $(".menu-parent-items.product.active").data('id');
        $(`.products-category-container`).addClass('hidden');
        $(`.products-category-container[data-id=${category_id}]`).removeClass('hidden');
    });


    // Funciones para detectar background

    function isTransparentColor(bg) {
        if (!bg || bg === 'transparent') return true;
        const m = bg.match(/rgba?\(([^)]+)\)/i);
        if (!m) return false;
        const nums = m[1].split(',').map(v => parseFloat(v.trim()));
        return nums.length === 4 && nums[3] === 0;
    }

    function getEffectiveBackgroundColor(el) {
        let node = el;
        while (node && node !== document.documentElement) {
            const bg = getComputedStyle(node).backgroundColor;
            if (!isTransparentColor(bg)) return bg;
            node = node.parentElement;
        }
        return getComputedStyle(document.body).backgroundColor || 'rgb(255,255,255)';
    }

    function getBrightness(rgb) {
        const match = rgb.match(/\d+/g);
        if (!match || match.length < 3) return 255;
        const [r, g, b] = match.map(Number);
        return (r * 299 + g * 587 + b * 114) / 1000;
    }

    function mapBrightnessToTheme(brightness) {
        return brightness < 128 ? 'darkPro' : 'lightGaleria';
    }

    function isFromAdminBar(el) {
        // true si el elemento es el adminbar o está dentro de él
        return !!(el && el.closest && el.closest('#wpadminbar'));
    }

    function themeAtPoint(x, y, headerEl) {
        const stack = (document.elementsFromPoint?.(x, y) || []);

        // descarta: el propio header, sus hijos, y cualquier elemento del adminbar
        const candidates = stack.filter(el =>
            el !== headerEl &&
            !headerEl.contains(el) &&
            !isFromAdminBar(el)
        );

        // 1) Prioriza IMG/VIDEO
        const media = candidates.find(el => el.tagName === 'IMG' || el.tagName === 'VIDEO');
        if (media) {
            const bg = getEffectiveBackgroundColor(media);
            return mapBrightnessToTheme(getBrightness(bg));
        }

        // 2) Primer elemento con fondo no transparente
        const withBg = candidates.find(el => !isTransparentColor(getComputedStyle(el).backgroundColor));
        if (withBg) {
            const bg = getEffectiveBackgroundColor(withBg);
            return mapBrightnessToTheme(getBrightness(bg));
        }

        // 3) fallback body
        return mapBrightnessToTheme(getBrightness(getComputedStyle(document.body).backgroundColor));
    }

    function resetHeaderTheme() {
        navbar_left.removeAttribute('data-theme');
        navbar_right.removeAttribute('data-theme');
    }

    function updateHeaderThemeFromVisual() {

        const headerRect = masthead.getBoundingClientRect();
        // La posición Y un píxel por debajo del header
        const y = Math.round(headerRect.bottom + 1);

        // usamos clientWidth en vez de innerWidth para evitar la barra de scroll
        const xLeft = 5;
        const xRight = Math.max(0, document.documentElement.clientWidth - 5);

        const leftTheme = themeAtPoint(xLeft, y, masthead);
        const rightTheme = themeAtPoint(xRight, y, masthead);

        if (leftTheme) navbar_left.setAttribute('data-theme', leftTheme);
        if (leftTheme === 'darkPro') {
            $masthead.removeClass('show-logo-glasses');
        } else if (leftTheme !== 'darkPro' && $(window).scrollTop() === 0) {
            $masthead.addClass('show-logo-glasses');
        }

        if (rightTheme) navbar_right.setAttribute('data-theme', rightTheme);
    }

    
/** Lighting product index list - Background swiper  */
    let hoverOpenTimeout;
    let hoverCloseTimeout;
    const delay = 300;
    
    
    // const $swiper = $(`#${swiper_id}`);
    const $sidebar = $("#sidebar-fullindex");


    function parseGalleryAttr(attr) {
        if (!attr) return [];
        let raw = attr;
        if (raw.includes('&quot;')) {
            raw = raw.replace(/&quot;/g, '"').replace(/&amp;/g, '&');
        }
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (err) {
            console.warn('No se pudo parsear data-gallery:', attr);
            return [];
        }
    }

    function preloadImages(urls=[0]) {
        return Promise.all(urls.map(src => new Promise(res => {
            const img = new Image();
            img.onload = img.onerror = res; 
            img.src = src;
        })));
    }

    const swiper1 = 'full-index-swiper';
    const swiper2 = 'full-index-swiper-2';
    const indexItems = document.querySelector("#sidebar-fullindex")
    const items = document.querySelectorAll(".menu-item-product[data-gallery]");
    const swiperEl = document.querySelector(`#${swiper1}`);
    const swiperEl2 = document.querySelector(`#${swiper2}`);

    let hoverToken = 0;

    function enterAnimation(swiperEl, swiper, myToken) {
        // gsap.killTweensOf(swiperEl);
        gsap.to(swiperEl, {
            // delay: .5,
            opacity: 1,
            duration: .8,
            ease: "power1.out",
            overwrite: "auto",
            onComplete: () => {
                swiper.autoplay.start();
            }
        })
       
    }

    function outAnimation(swiperEl, swiper, myToken) {
        //  gsap.killTweensOf(swiperEl);
         
        gsap.to(swiperEl, {
            delay: .8,
            opacity: 0,
            duration: .1,
            ease: "power1.out",
            overwrite: "auto",
            onComplete: () => {
                swiper.removeAllSlides();
            }
        })
       
    }

    function animationGalleries() {

        items.forEach(item => {
            item.addEventListener("mouseenter", async () => {
               
                const myToken = ++hoverToken;

                const gallery = parseGalleryAttr(item.dataset.gallery);
                 
                if (gallery.length == 0) return;
                await preloadImages(gallery);
                if (myToken !== hoverToken) return; 


                indexItems.setAttribute("data-theme", "darkPro");
                item.classList.add("active");

                const swiper = window.scSwipers[swiper1];
                const swiperback = window.scSwipers[swiper2];

                 const slides = gallery.map(img_url => `
                    <div class="swiper-slide bg-no-repeat bg-cover bg-center" style="background-image: url('${img_url}')"></div>
                `);
                
                if(!swiper.el.classList.contains("active")) {
                    swiper.appendSlide(slides);
                    swiper.slideTo(0, 0);
                    swiper.update();
                    swiper.el.classList.add('active');
                    swiperback.el.classList.remove('active');

                    enterAnimation(swiperEl, swiper, myToken); 
                    // outAnimation(swiperEl2, swiperback, myToken);


                } else {
                    swiperback.appendSlide(slides);
                    swiperback.slideTo(0, 0);
                    swiperback.update();
                    swiperback.el.classList.add('active');
                    swiper.el.classList.remove('active');
                   
                    // outAnimation(swiperEl, swiper, myToken);   
                    enterAnimation(swiperEl2, swiperback, myToken);
                 
                }
                
                
                
               
                
            })
            item.addEventListener("mouseleave", () => {
                const myToken = ++hoverToken;
                const swiper = window.scSwipers[swiper1];
                const swiperback = window.scSwipers[swiper2];
                
                indexItems.removeAttribute("data-theme", "darkPro");
                item.classList.remove("active");

                if(swiper.el.classList.contains("active")) {
                  outAnimation(swiperEl, swiper, myToken);

                } else {
                  outAnimation(swiperEl2, swiperback, myToken);
                }
                
            });
        });
    }

    animationGalleries();
    
    

    // $(".menu-item-product[data-gallery]").hover(
        
         
    //     async function() {

    //         // hoverOpenTimeout = setTimeout(() => {
    //             const $item = $(this);

    //             const swiper = window.scSwipers[swiper_id];

    //             const gallery = $item.data('gallery');
                
    //             if (gallery.length == 0) return;
                    
    //             swiper.removeAllSlides();

    //             const slides = gallery.map(img_url => `
    //                 <div class="swiper-slide bg-no-repeat bg-cover bg-center" style="background-image: url('${img_url}')"></div>
    //             `);

    //             swiper.appendSlide(slides);
    //             swiper.slideTo(0, 0);


    //             $item.addClass('active');
    //             // $sidebar.attr('data-theme', 'darkPro').addClass('swiper-bg');

    //             await preloadImages(gallery);
    //             $sidebar.attr('data-theme', 'darkPro').addClass('swiper-bg');
    //             $swiper.addClass('loaded');
                


    //             setTimeout(() => swiper.autoplay.start(), 300);
    //         // }, 300);
            
            

    // }, function() {

    //     // hoverCloseTimeout = setTimeout(() => {
    //         const $item = $(this); 

    //         const swiper = window.scSwipers[swiper_id];

    //         $sidebar.removeClass('swiper-bg');
    //         $swiper.removeClass('loaded');

    //         $sidebar.attr('data-theme', '');
    //         $item.removeClass('active');

    //         swiper.removeAllSlides();
        
    //     // }, 300);
    // });

});
 